"use strict";
import { GetHelpHeader } from "components/Modal/GetHelpHeader";
import { Button, Flex, Text } from "ui/src";
import { Modal } from "components/modals/Modal";
import { LearnMoreLink } from "components/text/LearnMoreLink";
import { isExtension } from "utilities/src/platform";
export function DialogV2({
  isOpen,
  onClose,
  icon,
  title,
  subtext,
  learnMoreUrl,
  learnMoreTextColor = "$neutral1",
  learnMoreTextVariant = "body3",
  modalName,
  primaryButtonText,
  primaryButtonOnClick,
  primaryButtonVariant = "branded",
  primaryButtonEmphasis,
  isPrimaryButtonLoading,
  secondaryButtonText,
  secondaryButtonOnClick,
  secondaryButtonVariant = "default",
  secondaryButtonEmphasis = "secondary",
  buttonContainerProps,
  alignment = isExtension ? "top" : void 0,
  children,
  displayHelpCTA = false,
  textAlign = "center"
}) {
  return <Modal alignment={alignment} isModalOpen={isOpen} name={modalName} onClose={onClose}>
      {displayHelpCTA && <GetHelpHeader closeModal={onClose} />}
      <Flex
    flexDirection="column"
    alignItems={textAlign === "center" ? "center" : "flex-start"}
    p="$spacing12"
    gap="$spacing8"
  >
        {icon}
        <Text variant="subheading1" color="$neutral1" mt="$spacing8">
          {title}
        </Text>
        {typeof subtext === "string" ? <Text variant="body3" color="$neutral2" textAlign={textAlign}>
            {subtext}
          </Text> : subtext}
        {learnMoreUrl && <LearnMoreLink url={learnMoreUrl} textColor={learnMoreTextColor} textVariant={learnMoreTextVariant} />}
        {children}
        <Flex gap="$spacing8" width="100%" mt="$spacing16" {...buttonContainerProps}>
          <Button
    variant={primaryButtonVariant}
    emphasis={primaryButtonEmphasis}
    minHeight="$spacing48"
    onPress={primaryButtonOnClick}
    loading={isPrimaryButtonLoading}
  >
            {primaryButtonText}
          </Button>
          {secondaryButtonText && secondaryButtonOnClick && <Button
    variant={secondaryButtonVariant}
    emphasis={secondaryButtonEmphasis}
    minHeight="$spacing48"
    onPress={secondaryButtonOnClick}
  >
              {secondaryButtonText}
            </Button>}
        </Flex>
      </Flex>
    </Modal>;
}
